/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserStoryTelling } from '51trips-frontend-core'

const remoteConfigConverter = {
  fromRemoteConfig: {
    userStorytellingData: (data: any) => {
      if (Array.isArray(data)) {
        const userStorytellingData: UserStoryTelling[] = []

        data.forEach((item) => {
          if (
            item.userID &&
            typeof item.userID === 'string' &&
            item.tripID &&
            typeof item.tripID === 'string'
          ) {
            const userStoryTelling = new UserStoryTelling(item.userID, item.tripID)
            userStorytellingData.push(userStoryTelling)
          }
        })

        return userStorytellingData
      }

      return []
    }
  }
}

export default remoteConfigConverter
